"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var discountPriceValueStyles_1 = require("./discountPriceValueStyles");
var Price_1 = require("../../prices/price/Price");
var DiscountPriceValue = function (_a) {
    var _b;
    var price = _a.price, priceDisplayType = _a.priceDisplayType, currency = _a.currency, _c = _a.showSign, showSign = _c === void 0 ? false : _c, _d = _a.boldPrice, boldPrice = _d === void 0 ? true : _d;
    var styles = discountPriceValueStyles_1.default();
    return (<core_1.Grid item={true} sm={3} xs={6} className={styles.priceContainer} data-test={'summary:car_details:discount:value'}>
      {showSign && '- '}
      <Price_1.default price={price} priceDisplayType={priceDisplayType} currency={currency} variant="caption" className={clsx_1.default(styles.price, [(_b = {}, _b[styles.boldPrice] = boldPrice, _b)])}/>
    </core_1.Grid>);
};
exports.default = DiscountPriceValue;
